import Alert from './Alert'
export default class SuccessfullyStoredAlert extends Alert{
    show() {
        return swal({
            title: this.key('title', uLang('app.success')),
            text: uLang('app.entity_created', {entity: this.key('entity')}),
            icon: "success",
            className: this.key('className'),
            buttons: {
                create_another: uLang('app.add_type', {type: this.key('entity')}),
                show: uLang('app.show_type', {type: this.key('entity')}),
            },
            closeOnClickOutside: false,
            closeOnEsc: false,
        });
    }
}
